import { Box, styled } from "@mui/material";

const LinearGradientBox = styled(Box)(({ theme }) => ({
  borderLeft: "solid 1.5px",
  borderRight: "solid 1.5px",
  borderColor: theme.palette.shades.secondary[500],
  opacity: 0.5,
  backgroundImage: `repeating-linear-gradient(-60deg, transparent 0px 3px, ${theme.palette.shades.secondary[500]} 3px 4px)`,
}));

export default LinearGradientBox;
